import React, { useContext, useEffect, useState } from 'react'
import SecurityDeposit from 'app/React/Components/Footer/SecurityDeposit'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";
import classNames from "classnames";

export default function DepositField(props) {
  const {
    currentVariant,
    isGlobalDownPaymentCash,
    isGlobalDownPaymentLeasing,
    order,
    strings,
    showGlobalDownPaymentReservationText,
  } = useContext(ConfiguratorContext)

  const footerStrings = strings.footer ?? {}
  const securityDepositLabel = currentVariant.security_deposit_label ?? false
  const [depositLabel, setDepositLabel] = useState(footerStrings.security_deposit)

  const isGlobalDownPayment =
    (order.paymentType === 'cash' && isGlobalDownPaymentCash) ||
    (order.paymentType === 'leasing' && isGlobalDownPaymentLeasing)

  useEffect(() => {
    let depositLabel

    if (securityDepositLabel) {
      depositLabel = securityDepositLabel
    } else if (isGlobalDownPayment && !props.skipGlobalDownPayment && !props.useDefaultDepositLabel) {
      if (order.paymentType === 'leasing') {
        depositLabel = footerStrings.security_deposit
      } else {
        depositLabel = footerStrings.security_deposit_today
      }
    } else if (order.paymentType === 'leasing') {
      depositLabel = footerStrings.total_security_deposit_leasing
    } else {
      depositLabel = footerStrings.security_deposit
    }

    setDepositLabel(depositLabel)
  }, [order.paymentType, securityDepositLabel, footerStrings.security_deposit, footerStrings.security_deposit_leasing])

  if (props.layout === 'overview') {
    return (
      <div className={classNames('config-overview__title', {
        'config-overview__title--without-border': props.withoutBorder
      })}>
        <div>
          {depositLabel}
          {isGlobalDownPayment && !props.skipGlobalDownPayment && showGlobalDownPaymentReservationText && (
            <span>{footerStrings.amount_is_reserved_today}</span>
          )}
        </div>
        <div>
          <SecurityDeposit
            type={isGlobalDownPayment && !props.skipGlobalDownPayment ? 'global-security-deposit' : 'security-deposit'}
          />
        </div>
      </div>
    )
  }

  return (
    <SecurityDeposit type={isGlobalDownPayment ? 'global-security-deposit' : 'security-deposit'}/>
  )
}

DepositField.defaultProps = {
  layout: 'footer',
  skipGlobalDownPayment: false,
  withoutBorder: false,
  useDefaultDepositLabel: false
}
